





























import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import SvgIcon from "@/components/SvgIcon.vue";

@Component({
  components: {
    SvgIcon
  }
})
export default class LoadingProductError extends Vue {}
